// extracted by mini-css-extract-plugin
module.exports = {"tabList":"AddProductForm_tabList__oM-wH react-tabs__tab-list","title":"AddProductForm_title__dahlZ"};